import { useEffect } from 'react';
import { TitleRowTabOperations } from 'components/TitleRowTabOperations';
import { PaymentsOperationsItem } from 'ui/PaymentsOperationsItem';
import { useGetTabOperationsQuery } from 'redux/Api/operationsApi/operationsApi';
import { useDispatch } from 'react-redux';
import { setCountTab } from 'redux/operationInfo/slice';
import { LoadingSkeleton } from 'components/LoadingSkeleton';
import { Link } from 'react-router-dom';
import { Nothing } from 'components/Nothing';
import styles from './Payments.module.scss';

interface PaymentsPropsTypes {
  title: string;
}

export const Payments = ({ title }: PaymentsPropsTypes) => {
  const { data, isLoading } = useGetTabOperationsQuery({ title });
  const dispatch = useDispatch();

  useEffect(() => {
    if (data) dispatch(setCountTab({ countTab: data.count, nameTab: 'Платежи' }));
  }, [data]);

  const dataPayments = [
    'Дата создания',
    'id',
    'Заказчик',
    'Получатель',
    'Тип платежа',
    'Сумма',
    'Дата обновления',
    'Статус',
  ];

  return (
    <div>
      {isLoading ? (
        <LoadingSkeleton widthTab />
      ) : (
        <>
          <TitleRowTabOperations data={dataPayments} title={title} />
          {data ? (
            <div className={styles.window}>
              {data.items.map((item) => {
                if (!item || !('amount' in item)) return null;
                return (
                  <Link key={item.id} to={`/operations/payments/${item.id}`}>
                    <PaymentsOperationsItem payment={item} />
                  </Link>
                );
              })}
            </div>
          ) : (
            <Nothing style={{ height: '660px' }} title='Ничего не найдено' />
          )}
        </>
      )}
    </div>
  );
};
